<template lang="html">
  <div class="agent-detail-commission-out--inner">
    <div class="window-details-toolbar">

    </div>

    <tbl
    >
      <tbl-inner>
        <tbl-head>
          <tbl-row>
            <tbl-td
              :sort="true"
              @click.native="sort('request_date')"
              name="request-date">
              request date
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('confirm_date')"
              name="confirm-date">
              confirm date
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('old_amount')"
              name="old-amount">
              old amount

            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('amount')"
              name="amount">
             amount
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('new_amount')"
              name="new-amount">
              new amount
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('admin_id')"
              name="admin-id">
              admin id
            </tbl-td>

          </tbl-row>
        </tbl-head>
        <tbl-body>
          <tbl-row
          >
            <tbl-td name="request-date">
              request date
            </tbl-td>

            <tbl-td name="confirm-date">
              confirm date
            </tbl-td>

            <tbl-td name="old-amount">
              old amount

            </tbl-td>

            <tbl-td name="amount">
             amount
            </tbl-td>

            <tbl-td name="new-amount">
              new amount
            </tbl-td>

            <tbl-td name="admin-id">
              admin id
            </tbl-td>

          </tbl-row>
        </tbl-body>
      </tbl-inner>

      <tbl-footer>
        <pagination
          :total="agentCodesCnt"
          v-model="params.page"
          :rows="params.rows"
          @page="trigger"
        >
        </pagination>
      </tbl-footer>

    </tbl>

  </div>
</template>

<script>
export default {
  name: 'agent-detail-commission-out'
}
</script>
